export const IMAGES = {
  logo: require("src/images/files/logo.png"),
  transparentLogo: require("src/images/files/logo-transparent.png"),
  aboutUs: require("src/images/files/about-us.png"),
  contactUs: require("src/images/files/contact-us.png"),
  empty: require("src/images/files/404.png"),
};
